import { render } from "./WebSettings.vue?vue&type=template&id=45c54332&scoped=true"
import script from "./WebSettings.vue?vue&type=script&lang=js"
export * from "./WebSettings.vue?vue&type=script&lang=js"

import "./WebSettings.vue?vue&type=style&index=0&id=45c54332&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c54332"]])

export default __exports__